import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/station/co2.svg'
import _imports_1 from '@/assets/station/tree.svg'
import _imports_2 from '@/assets/station/tan.svg'


const _withScopeId = n => (_pushScopeId("data-v-2a9d3e5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "low-carbon-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-2a9d3e5b>社会贡献</div><div class=\"item-flex\" data-v-2a9d3e5b><div data-v-2a9d3e5b></div><div data-v-2a9d3e5b><div class=\"title-icon\" data-v-2a9d3e5b><img src=\"" + _imports_0 + "\" alt=\"co2.svg\" data-v-2a9d3e5b></div><div data-v-2a9d3e5b>CO2 减排量 kg</div></div><div data-v-2a9d3e5b><div class=\"title-icon\" data-v-2a9d3e5b><img src=\"" + _imports_1 + "\" alt=\"tree.svg\" data-v-2a9d3e5b></div><div data-v-2a9d3e5b>等效植树量 棵</div></div><div data-v-2a9d3e5b><div class=\"title-icon\" data-v-2a9d3e5b><img src=\"" + _imports_2 + "\" alt=\"tree.svg\" data-v-2a9d3e5b></div><div data-v-2a9d3e5b>节约标准煤 kg</div></div></div>", 2)
const _hoisted_4 = { class: "item-flex bg-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当日", -1))
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "item-flex bg-col" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "累计", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "value" }


import { GetEssEnergyConversionStatsReply } from '@/views/DataV/Photovoltaic/types'

export default /*#__PURE__*/_defineComponent({
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data?: Partial<GetEssEnergyConversionStatsReply>
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(props.data?.dailyReduceCarbon?.toFixed(0) || 0), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(props.data?.dailyPlantingTrees?.toFixed(0) || 0), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(props.data?.dailyReduceCoal?.toFixed(0) || 0), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, _toDisplayString(props.data?.cumulativeReduceCarbon?.toFixed(0) || 0), 1),
      _createElementVNode("div", _hoisted_12, _toDisplayString(props.data?.equivalentPlantingTrees?.toFixed(0) || 0), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(props.data?.cumulativeReduceCoal?.toFixed(0) || 0), 1)
    ])
  ]))
}
}

})